import React, { Suspense } from "react";
import { renderRoutes } from "react-router-config";
import { ProgressBar } from "react-bootstrap";
import PropTypes from "prop-types";

import logo from "assets/comexLogo.png"; // Ajuste o caminho do seu logo

const page = {
  minHeight: "100vh",
  backgroundColor: "#f5f6f8",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px"
};

const card = {
  width: "100%",
  maxWidth: "500px",
  backgroundColor: "#FFFFFF",
  borderRadius: "12px",
  padding: "40px",
  boxShadow: "0 10px 30px rgba(0,0,0,.12)"
};

const logoContainer = {
  display: "flex",
  justifyContent: "center",
  marginBottom: "35px"
};

const logoStyle = {
  maxWidth: "260px",
  width: "100%"
};

const PublicCard = props => {
  const { route } = props;

  return (
    <div style={page}>

      <div style={card}>

        <div style={logoContainer}>
          <img
            src={logo}
            alt="Number One"
            style={logoStyle}
          />
        </div>

        <Suspense
          fallback={
            <ProgressBar
              animated
              striped
            />
          }
        >
          {renderRoutes(route.routes)}
        </Suspense>

      </div>

    </div>
  );
};

PublicCard.propTypes = {
  route: PropTypes.object
};

export default PublicCard;